import fromBreed from './fromBreed';
import fromBull from './fromBull';

const location = {
  fromBreed,
  fromBull
};

export default location;